import WorkOutlinedIcon from "@mui/icons-material/WorkOutlined";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { INK } from "../../theme/tokens";
import type { Nurse } from "../../utils/models";
import { isAgencyNurse } from "../../utils/utilFunctions";
import { InHouseTooltip } from "../InHouseTooltip/InHouseTooltip";

export const NurseAgencyIndicator: FC<{ person: Pick<Nurse, "agencyName" | "employmentType"> | undefined }> = ({ person }) => {
	const { t } = useTranslation();

	if (!person || (!person.agencyName && !isAgencyNurse(person.employmentType))) {
		return null;
	}

	return (
		<InHouseTooltip title={person.agencyName || t("agency")}>
			<WorkOutlinedIcon data-testid="nurse-agency-indicator" sx={{ fontSize: { xs: 12, sm: 14 }, color: INK.SECONDARY }} />
		</InHouseTooltip>
	);
};
